import { useState, useRef } from 'react';

/**
 * Form state management hook for PostBoxModal
 */
export const usePostBoxState = () => {
  // Main state variables
  const [step, setStep] = useState(1);
  const [tag, setTag] = useState(null);
  const [issue, setIssue] = useState(null);
  const [selectedScale, setSelectedScale] = useState(null);
  const [location, setLocation] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [images, setImages] = useState([]);
  const [locationSearchTerm, setLocationSearchTerm] = useState('');
  const [issueSearchTerm, setIssueSearchTerm] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSearchingLocation, setIsSearchingLocation] = useState(false);
  const [locationError, setLocationError] = useState('');
  const [selectedIssueStatus, setSelectedIssueStatus] = useState('');
  const [contentFocused, setContentFocused] = useState(false);
  const [titleFocused, setTitleFocused] = useState(false);
  const [titleError, setTitleError] = useState(false);
  const [link, setLink] = useState("");
  const [linkError, setLinkError] = useState(false);
  const [linkAnchorEl, setLinkAnchorEl] = useState(null);
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [linkPreview, setLinkPreview] = useState(null);
  const [isLoadingPreview, setIsLoadingPreview] = useState(false);
  const lastFetchedUrl = useRef(null);

  return {
    // State
    step,
    tag,
    issue,
    selectedScale,
    location,
    selectedLocation,
    title,
    content,
    images,
    locationSearchTerm,
    issueSearchTerm,
    isSubmitting,
    isSearchingLocation,
    locationError,
    selectedIssueStatus,
    contentFocused,
    titleFocused,
    titleError,
    link,
    linkError,
    linkAnchorEl,
    showLinkInput,
    linkPreview,
    isLoadingPreview,
    lastFetchedUrl,

    // Setters
    setStep,
    setTag,
    setIssue,
    setSelectedScale,
    setLocation,
    setSelectedLocation,
    setTitle,
    setContent,
    setImages,
    setLocationSearchTerm,
    setIssueSearchTerm,
    setIsSubmitting,
    setIsSearchingLocation,
    setLocationError,
    setSelectedIssueStatus,
    setContentFocused,
    setTitleFocused,
    setTitleError,
    setLink,
    setLinkError,
    setLinkAnchorEl,
    setShowLinkInput,
    setLinkPreview,
    setIsLoadingPreview,
  };
};

export default usePostBoxState;
